import { useState } from 'react';
import classnames from 'classnames';

import { Surface, surfaceKeys } from '../../src';
import type { Surfaces, WithOptionalSurface } from '../../src';

export function SurfaceWrapper({
  children,
  type: initialSurface = 'base',
  onChange,
  ...rest
}: WithOptionalSurface<Omit<React.ComponentProps<'div'>, 'onChange'>> & {
  onChange?: (surface: Surfaces) => void;
}) {
  const [internalType, setInternalType] = useState<Surfaces>(initialSurface);
  const type = onChange ? initialSurface : internalType;
  const handleChange = (surface: Surfaces) => {
    if (onChange) {
      onChange(surface);
    } else {
      setInternalType(surface);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-2">
      <div className="flex gap-2">
        <span className="font-bold">Surface: </span>
        {surfaceKeys.map((surface) => (
          <button
            key={surface}
            type="button"
            className={classnames('capitalize', {
              underline: surface === type,
            })}
            onClick={() => handleChange(surface)}
            data-surface={surface}
          >
            {surface}
          </button>
        ))}
      </div>
      <Surface {...rest} type={type} className={classnames('p-4 shadow', rest.className)}>
        {children}
      </Surface>
    </div>
  );
}
